module.exports = __webpack_public_path__ + "static/media/background-photo4096.be6a1c4c.jpg";